import { render, staticRenderFns } from "./MusicAlbum.vue?vue&type=template&id=2b5edfd1&scoped=true&"
import script from "./MusicAlbum.vue?vue&type=script&lang=js&"
export * from "./MusicAlbum.vue?vue&type=script&lang=js&"
import style0 from "./MusicAlbum.vue?vue&type=style&index=0&id=2b5edfd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5edfd1",
  null
  
)

export default component.exports